export default __webpack_public_path__ + "static/media/ic_glp_40.83715d51.svg";